export const CLOUD = 'cloud';
export const SERVER = 'server';
export const DATACENTER = 'datacenter';

export type DeploymentOption = 'cloud' | 'server' | 'datacenter';

export const DeploymentOptions: DeploymentOption[] = [SERVER, DATACENTER, CLOUD];

export const OrderedDeploymentOptions = [CLOUD, DATACENTER, SERVER];
